import { base44 } from './base44Client';


export const Lesson = base44.entities.Lesson;

export const UserProgress = base44.entities.UserProgress;

export const DailyCheckIn = base44.entities.DailyCheckIn;

export const LessonFeedback = base44.entities.LessonFeedback;



// auth sdk:
export const User = base44.auth;